import React from 'react';
import { SuccessMessage } from '../SuccessMessage';
import { useToastStore } from '../../store/toastStore';

export const ToastContainer: React.FC = () => {
  const toast = useToastStore(state => state.toast);
  const dismissMessage = useToastStore(state => state.dismissMessage);

  if (!toast) {
    return null;
  }

  return (
    <SuccessMessage
      type={toast.type}
      title={toast.title}
      message={toast.message}
      onClose={dismissMessage}
    />
  );
};
